var map = {
	"./framenew_box00.jpg": "4143",
	"./framenew_box01.jpg": "e225",
	"./framenew_box02.jpg": "64c1",
	"./framenew_box03.jpg": "a08f",
	"./framenew_box04.jpg": "4dc1",
	"./framenew_box05.jpg": "8619",
	"./framenew_box06.jpg": "f0f0",
	"./framenew_box07.jpg": "c1d8",
	"./framenew_box08.jpg": "d294",
	"./framenew_box09.jpg": "d778",
	"./framenew_box10.jpg": "250d",
	"./framenew_box11.jpg": "f21f",
	"./framenew_box12.jpg": "c1bc",
	"./framenew_box13.jpg": "8996",
	"./framenew_box14.jpg": "36f0",
	"./framenew_box15.jpg": "7e50",
	"./framenew_box16.jpg": "50da",
	"./framenew_box17.jpg": "6c32",
	"./framenew_box18.jpg": "0a25",
	"./framenew_box19.jpg": "8ad9",
	"./framenew_box20.jpg": "572b",
	"./framenew_box21.jpg": "e28f",
	"./framenew_box22.jpg": "c309",
	"./framenew_box23.jpg": "3f01",
	"./framenew_box24.jpg": "9e78",
	"./framenew_box25.jpg": "402f",
	"./framenew_box26.jpg": "1ceb",
	"./framenew_box27.jpg": "b0bd",
	"./framenew_box28.jpg": "8238",
	"./framenew_box29.jpg": "ffaa",
	"./framenew_box30.jpg": "7c64"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d76";